import { FormComponentTypes } from '../constants'
import headingValidator from './Body/Components/Heading/validator'
import labelValidator from './Body/Components/Label/validator'
import checkboxValidator from './Body/Components/Checkbox/validator'
import radioButtonValidator from './Body/Components/RadioButton/validator'
import inputTextValidator from './Body/Components/InputText/validator'
import inputNumberValidator from './Body/Components/InputNumber/validator'

const componentValidators = {
  [FormComponentTypes.Heading]: headingValidator,
  [FormComponentTypes.Label]: labelValidator,
  [FormComponentTypes.Checkbox]: checkboxValidator,
  [FormComponentTypes.RadioButton]: radioButtonValidator,
  [FormComponentTypes.InputText]: inputTextValidator,
  [FormComponentTypes.InputNumber]: inputNumberValidator,
}

export const validateComponents = (components) => {
  components.forEach((component) => {
    const validator = componentValidators[component.type]
    if (validator) {
      validator(component)
    } else {
      component.isValid = true
    }
  })
  const hasInvalidComponent = components.some((component) => !component.isValid)
  return !hasInvalidComponent
}
